import { React } from 'vendor-react';

function Label(props) {
    const { text, info } = getTextAndInfo();
    const { className, onTooltipClick, required, emailLabel } = props;

    function getTextAndInfo() {
        const { label } = props;
        if (label instanceof Object) {
            return {
                text: label.text,
                info: label.info,
            };
        } else {
            return { text: label };
        }
    }

    return (
        <label className={className} data-emaillabel={emailLabel}>
            <span className="label__text">{text}</span>
            {info && <span className="label__info" title={info} />}
            {!required && <span className="label__optional">Optional</span>}
            {onTooltipClick && <span className="label__tooltip" onClick={onTooltipClick} />}
        </label>
    );
}

export default Label;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/modules/react-forms/scripts/Components/Label/index.js